import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"



	// eslint-disable-next-line
	
// name the component
	const __default__ = { name: 'TwTableHeader' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		defaultSort: {
			type: Object,
			default: () => {return {prop: null, order: 'ASC'}}
		}
	},
  setup(__props) {

const props = __props;

	

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", { ref: "column" })
}
}

})